export default __webpack_public_path__ + "static/media/empties.cfbb1b13.svg";